/**
 *  @class
 *  @function ShopTheLook
 */
if (!customElements.get('shop-the-look')) {
    class ShopTheLook extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.dots = this.querySelectorAll('.thb-hotspot');

            this.setEventListeners();
        }
        setEventListeners() {
            this.dots.forEach((dot, index) => {
                this.checkCardPosition(dot);
                window.addEventListener('resize', () => {
                    this.checkCardPosition(dot);
                });
            });
            window.dispatchEvent(new Event('resize'));
        }
        checkCardPosition(dot) {
            let dotBounds = dot.querySelector('.thb-hotspot-bubble').getBoundingClientRect(),
                imageBounds = this.getBoundingClientRect();

            if (dotBounds.bottom > document.documentElement.clientHeight || dotBounds.bottom > imageBounds.bottom) {
                dot.classList.add('bottom-dot');
            } else {
                dot.classList.remove('bottom-dot');
            }
            if (dotBounds.right > imageBounds.right) {
                dot.style.setProperty('--content-offset', `${imageBounds.right - dotBounds.right - 15}px`);
            } else if (dotBounds.left < imageBounds.left) {
                dot.style.setProperty('--content-offset', `${imageBounds.left - dotBounds.left + 15}px`);
            }
        }
    }
    customElements.define('shop-the-look', ShopTheLook);
}

/**
*  @class
*  @function QuickView
*/
if (!customElements.get('quick-view')) {
    class QuickView extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.drawer = document.getElementById('Product-Modal');
            this.body = document.body;

            this.addEventListener('click', this.setupEventListener.bind(this));
            this.addEventListener('keypress', this.setupEventListener.bind(this));
        }
        setupEventListener(e) {
            if (e.key && e.key !== 'Enter') {
                return;
            }
            e.preventDefault();
            let productHandle = this.dataset.productHandle,
                href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

            // remove double `/` in case shop might have /en or language in URL
            href = href.replace('//', '/');
            if (!href || !productHandle) {
                return;
            }
            if (this.classList.contains('loading')) {
                return;
            }
            this.classList.add('loading');
            fetch(href, {
                method: 'GET'
            })
                .then((response) => {
                    this.classList.remove('loading');
                    return response.text();
                })
                .then(text => {
                    const sectionInnerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('#Product-Modal-Content').innerHTML;
                    this.renderQuickview(sectionInnerHTML, href, productHandle);
                });
        }
        renderQuickview(sectionInnerHTML, href, productHandle) {
            if (sectionInnerHTML) {
                this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

                let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

                if (js_files.length > 0) {
                    var head = document.getElementsByTagName('head')[0];
                    js_files.forEach((js_file, i) => {
                        let script = document.createElement('script');
                        script.src = js_file.src;
                        head.appendChild(script);
                    });
                }

                setTimeout(() => {
                    if (Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    if (window.ProductModel) {
                        window.ProductModel.loadShopifyXR();
                    }
                }, 300);

                this.drawer.setAttribute('open', '');
                this.drawer.querySelector('.product-modal__toggle').focus();

                setTimeout(() => {
                    let slider = this.drawer.querySelector('#Product-Slider');

                    slider.reInit();
                    window.dispatchEvent(new Event('resize'));
                }, 100);

                dispatchCustomEvent('quick-view:open', {
                    productUrl: href,
                    productHandle: productHandle
                });
                addIdToRecentlyViewed(productHandle);
            }
        }
    }
    customElements.define('quick-view', QuickView);
}